import { jsx as _ } from "react/jsx-runtime";
import "react";
import { getSocialNetworkLink as c } from "./utils/createSocialShareLinks.js";
import { classes as l, windowOpen as h } from "./utils/helpers.js";
import './assets/SocialShareButton.css';const u = {
  "social-share": "_social-share_qvnyi_1",
  "social-share__button": "_social-share__button_qvnyi_5",
  "social-share__icon": "_social-share__icon_qvnyi_10"
};
function f({ children: s, network: o, url: t, text: i, longtext: n }) {
  const e = (a) => {
    a.preventDefault();
    const r = c({ network: o, url: t, text: i, longtext: n });
    h(r);
  };
  return /* @__PURE__ */ _(
    "button",
    {
      className: l(["social-share__button", u["social-share__button"]]),
      "aria-label": `Share on ${o}`,
      onClick: (a) => e(a),
      title: `Share on ${o}`,
      children: s
    }
  );
}
export {
  f as S,
  u as s
};
